import React, { useCallback, useRef, useState, useEffect } from "react";
import { getCookieValue, setCookie } from "../Utiilities/Cookies";

const PopUpAd = ({ dfpZone, APPLICATION_POPUP_ADVERT_CLOSE_DURATION = 7 }) => {
  const [openPopUp, setOpenPopUp] = useState({ showing: false, dismissed: false });
  const [adReady, setAdReady] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);

  const popUpRef = useRef(false);

  // Function to show the ad
  const showAd = useCallback(() => {
    setOpenPopUp({ showing: true, dismissed: false });
  }, []);

  // Function to hide the ad
  const hide = useCallback(() => {
    setOpenPopUp({ showing: false, dismissed: true });
    setCookie("dismissPopup", "true", APPLICATION_POPUP_ADVERT_CLOSE_DURATION);
  }, []);

  // Load ad when the popup is open
  useEffect(() => {
    if (openPopUp.showing && window.googletag) {
      const LoadNewAdsEvent = new CustomEvent("LoadNewAds", { detail: [popUpRef.current] });
      window.dispatchEvent(LoadNewAdsEvent);
    }
  }, [openPopUp.showing]);

  // Calculate scroll percentage
  useEffect(() => {
    const handleScroll = () => {
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight;
        const winHeight = window.innerHeight;
        const totalScroll = docHeight - winHeight;

        if (totalScroll > 0) {
          const percent = (scrollTop / totalScroll) * 100;
          setScrollPercent(percent);
        } else {
          setScrollPercent(0);
        }
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // Set initial value
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Check if the user has scrolled more than 50% of the page and show the ad
  useEffect(() => {
    if (!openPopUp.dismissed && !openPopUp.showing && scrollPercent >= 50) {
      showAd();
    }
    return () => {};
  }, [openPopUp, scrollPercent, showAd]);

  // Check if the user has previously dismissed the popup on load to determine whether we load the ad at all
  useEffect(() => {
    if (typeof window !== "undefined") {
      const dismissPopup = getCookieValue("dismissPopup");

      // don't do anything with popup if previously dismissed
      if (!dismissPopup) {
        setAdReady(true); // ad is ready to be shown

        // Timeout to trigger ad after 7 seconds
        const timer = setTimeout(showAd, 7000);

        // Cleanup: remove the timer and observer when unmounting
        return () => {
          clearTimeout(timer);
        };
      }
    }
    return () => {};
  }, [showAd]);

  if (!adReady) {
    return null; // no ad until after the page has loaded
  }

  return (
    <div id="PopUpAd" className={openPopUp.showing ? "show" : ""}>
      <button aria-label="Close modal" onClick={hide} title="Close">
        <span>CLOSE</span>
        <i className="fa-regular fa-close" />
      </button>
      <section
        id={dfpZone.replace(/[^a-z0-9]{1,}/gi, "-").toLowerCase()}
        className="popUp-ad advertisement"
        data-zone={dfpZone}
      />
    </div>
  );
};

export default PopUpAd;
